const domainActionTypes = {
    add: 'Add Domains',
    changeType: 'Change Domain Type',
    remove: 'Remove Domains'
};

export default domainActionTypes;
